import { Text, Box, Flex } from "@chakra-ui/react";
import { minHeight, quizColors } from "../../hooks/use-guide";
import { QuizQuestion } from "../../services/guides/types";
import NextPrevButtons from "../next-prev-buttons";

interface Props {
  quizIndex: number;
  questions: QuizQuestion[];
  onNext: () => void;
  onPrev: () => void;
}

export default function ViewProgress(props: Props) {
  return (
    <>
      <Box
        backgroundColor={quizColors.primary}
        w={"100%"}
        h="100%"
        position={"absolute"}
        left={0}
        top={0}
      ></Box>
      <Flex
        id="view-progress"
        zIndex={1}
        color="white"
        justifyContent={"center"}
        alignItems="center"
        h={minHeight}
      >
        <Flex position={"relative"}>
          <Box borderRight="1px dashed white" display={{ base: "none", md: "block" }}></Box>
          <Flex flexDir="column">
            {props.questions.map((q, i) => (
              <Box key={i} position="relative" my={4}>
                <Box
                  position={"absolute"}
                  backgroundColor="white"
                  w="15px"
                  h="15px"
                  borderRadius={"100px"}
                  ml={"-8px"}
                  mt={"5px"}
                ></Box>
                <Text pl={8} opacity={props.quizIndex >= i ? 1 : 0.3}>
                  {q.title}
                </Text>
              </Box>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <NextPrevButtons
        showNext
        showPrev
        onNextClick={props.onNext}
        onPrevClick={props.onPrev}
        color="white"
      />
    </>
  );
}
